import React from "react"

import { Button, ActionButton } from "./styles"
import theme from '../../theme'

import { MenuIcon, HomeIcon, PrevIcon, NextIcon, HelpIcon, DownloadIcon, ReplayIcon } from './icons'
//Disponíveis também: AudioIcon, CloseIcon, ZoomIcon

export default function (props) {
  const { type, color, margin, to, disabled, opacity, onClick, tooltip } = props

  const Icon = () => {
    return (
      <>
        {
          {
            home: <HomeIcon fill={theme.palette.button.roundButtonIcon}/>,
            menu: <MenuIcon fill={theme.palette.button.roundButtonIcon}/>,
            help: <HelpIcon fill={theme.palette.button.roundButtonIcon}/>,
            replay: <ReplayIcon fill={theme.palette.button.roundButtonIcon}/>,
            previous: <PrevIcon fill={theme.palette.button.roundButtonIcon}/>,
            next: <NextIcon fill={theme.palette.button.roundButtonIcon}/>,
            download: <DownloadIcon fill={theme.palette.button.roundButtonIcon}/>,
            //adicionar mais conforme necessário
          }[type]
        }
      </>
    )    
  }

  return (
    <>
      {to ? (
        <Button to={to} color={color} margin={margin} tooltip={tooltip} data-tooltip={tooltip}>          
          <Icon type={type} disabled={disabled}/>
        </Button>
      ) : (
        <>
          {disabled ? (
            <ActionButton disabled />            
          ) : (
            <>
              {opacity ? (
                <ActionButton color={color} margin={margin} opacity>
                  <Icon type={type} disabled={disabled}/>
                </ActionButton>
              ) : (
                <ActionButton color={color} margin={margin} tooltip={tooltip} onClick={onClick} data-tooltip={tooltip}>
                  <Icon type={type} disabled={disabled}/>
                </ActionButton>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
